import { render, staticRenderFns } from "./AdminArticleInstructionsEditor.vue?vue&type=template&id=131814ec&scoped=true&"
import script from "./AdminArticleInstructionsEditor.vue?vue&type=script&lang=js&"
export * from "./AdminArticleInstructionsEditor.vue?vue&type=script&lang=js&"
import style0 from "./AdminArticleInstructionsEditor.vue?vue&type=style&index=0&id=131814ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131814ec",
  null
  
)

export default component.exports